<template>
  <q-page padding>
    <div class="relative-position loader">
      <pending-changes></pending-changes>
    </div>
  </q-page>
</template>

<script>
import PendingChanges from '../../../components/pendingApproval/pendingChanges'

export default {
  name: 'Entry',
  components: {PendingChanges}
}
</script>
